import React from 'react';
import { TableHead } from '../../../../components/ui/table';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

// Reusable sortable header
export const SortableHeader = ({ label, sortKey, sortState, onSort, className = '' }) => (
  <TableHead
    className={`cursor-pointer select-none hover:bg-gray-100 transition-colors ${className}`}
    onClick={() => onSort(sortKey)}
  >
    <div className="flex items-center gap-1">
      {label}
      {sortState.key === sortKey
        ? (sortState.dir === 'asc' ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />)
        : <ChevronsUpDown className="h-3 w-3 text-gray-300" />}
    </div>
  </TableHead>
);

// Date field keys that need proper date parsing for sorting
export const DATE_SORT_KEYS = new Set(['transaction_date', 'date', 'created_at', 'updated_at', 'value_date', 'posting_date']);

// Resolve dot-notation paths like "recorded.transaction_date"
export const getNestedValue = (obj, path) => {
  if (!path || !obj) return undefined;
  return path.split('.').reduce((o, k) => (o != null ? o[k] : undefined), obj);
};

// Check if any segment of a dot path is a date key
export const isDatePath = (path) => {
  const parts = path.split('.');
  return parts.some(p => DATE_SORT_KEYS.has(p));
};

// Generic sort function with proper date handling and dot-path support
export const sortItems = (items, sortState) => {
  if (!sortState.key) return items;
  const dateSort = isDatePath(sortState.key);
  return [...items].sort((a, b) => {
    let va = getNestedValue(a, sortState.key);
    let vb = getNestedValue(b, sortState.key);
    if (va == null) va = '';
    if (vb == null) vb = '';
    if (dateSort) {
      const da = va ? new Date(va).getTime() : 0;
      const db = vb ? new Date(vb).getTime() : 0;
      const safeA = isNaN(da) ? 0 : da;
      const safeB = isNaN(db) ? 0 : db;
      return sortState.dir === 'asc' ? safeA - safeB : safeB - safeA;
    }
    if (typeof va === 'number' && typeof vb === 'number') return sortState.dir === 'asc' ? va - vb : vb - va;
    va = String(va).toLowerCase(); vb = String(vb).toLowerCase();
    return sortState.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
  });
};
